document.addEventListener("DOMContentLoaded", function () {
  // Keeps the Header Search open even when the page is scrolled
  const details = document.querySelector('.header__search details');
  if (details) {
    window.addEventListener('scroll', function (event) {
      details.setAttribute('open', 'open');
    });
  }

  // When the search bar is focused/active on 990px and above,
  // expand the width to accommodate the search suggestions/results
  const headerSearch = document.querySelector('.fc-header-search');
  if (headerSearch) {
    const searchInput = headerSearch.querySelector('.search__input');
    searchInput.addEventListener('focus', function () {
      if (window.innerWidth >= 990) {
        headerSearch.classList.add('expanded');
      }
    });
    searchInput.addEventListener('focusout', function (e) {
      if (window.innerWidth >= 990) {
        // Check if the new focused element is within the container
        const isClickInside = headerSearch.contains(e.relatedTarget);

        // Only remove expanded if clicking outside the container
        if (!isClickInside) {
          headerSearch.classList.remove('expanded');
        }
      }
    });
  }

  // Mega menu
  // Initialize Mega Menu
  const initHardwareMegaMenu = () => {
    const categoryButtons = document.querySelectorAll('.mega-menu__category-link');

    // Set the first item as active initially
    if (categoryButtons.length > 0) {
      categoryButtons[0].classList.add('mega-menu__category-link--active');
    }

    categoryButtons.forEach(button => {
      // Change from click to mouseenter event
      button.addEventListener('mouseenter', function () {
        // Update active states
        categoryButtons.forEach(btn => btn.classList.remove('mega-menu__category-link--active'));
        this.classList.add('mega-menu__category-link--active');
      });

      // Add click event for navigation
      button.addEventListener('click', function() {
        const url = this.getAttribute('data-url');
        if (url) {
          window.location.href = url;
        }
      });
    });
  };

  // Run and observe for changes
  initHardwareMegaMenu();

  const menuObserver = new MutationObserver(() => {
    if (document.querySelector('.mega-menu__layout')) {
      initHardwareMegaMenu();
    }
  });

  menuObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});